import React from 'react';
import { Image, Markup } from '@landing/ui';
import { Container } from 'components/UI';
import * as styles from './Intro.module.scss';

export default function Intro({ title, subtitle, img }) {
  return (
    <Container background="white" padding="Without">
      <Container className={styles.innerContainer} theme="inner" background="darkPrimary">
        <Image className={styles.picture} classImage={styles.img} src={img} />
        <div className={styles.layout}>
          <Markup tag="h1" className={styles.title} color="white">
            {title}
          </Markup>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </Container>
    </Container>
  );
}
